export default __webpack_public_path__ + "static/summer_containers14-94caf0a4905dbd19f7eb3fe6666f4f34.webp";